import styled from "styled-components";

const Box = styled.div`
  border-radius: ${(props) => props.theme.borderRadius.light};
  background: ${(props) => props.theme.colors.componentBackgroundColor.primary};
  padding: ${(props) => props.theme.spacing.light};
`;

export default Box;
